<template>
  <div class="earthquake-history">
    <el-card shadow="always" class="history-card">
      <div slot="header" class="card-header">
        <i class="el-icon-document-copy header-icon"></i>
        <span class="header-title">歷史地震報告</span>
      </div>

      <el-table
        v-loading="loading"
        :data="pagedReports"
        border
        stripe
        highlight-current-row
        class="history-table"
        empty-text="目前沒有歷史報告"
      >
        <el-table-column
          prop="name"
          label="檔案名稱"
          min-width="320"
          header-align="center"
          show-overflow-tooltip
        />
        <el-table-column
          prop="modified"
          label="生成日期"
          width="200"
          align="center"
        />
        <el-table-column
          prop="size"
          label="檔案大小"
          width="120"
          align="center"
        />
        <el-table-column label="操作" width="150" align="center">
          <template v-slot="scope">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-download"
              plain
              @click="downloadReport(scope.row)"
            >
              下載報告
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分頁控制 -->
      <div class="pagination-wrapper">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="reportList.length"
          @current-change="handlePageChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'EarthquakeHistory',
  data() {
    return {
      loading: false,
      reportList: [],
      currentPage: 1,
      pageSize: 10,
    };
  },
  computed: {
    // 只顯示當前分頁的資料
    pagedReports() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.reportList.slice(start, end);
    },
  },
  methods: {
    async fetchReports() {
      this.loading = true;
      try {
        const res = await fetch('https://api-thsr-main.geosupply.com.tw/api/docx/list', {
          headers: {
            'Authorization': localStorage.getItem('jwt'),
          },
        });
        const data = await res.json();

        if (data.success && data.files) {
          this.reportList = data.files
            .map(f => {
              const date = new Date(f.modified);
              const formattedDate = date.toLocaleString('zh-TW', {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: false,
              });

              return {
                name: this.formatReportName(f.name),
                url: f.url,
                size: f.sizeKB,
                modified: formattedDate,
              };
            })
            .sort((a, b) => b.name.localeCompare(a.name, undefined, { numeric: true }));
        } else {
          this.reportList = [];
        }
      } catch (err) {
        console.error('載入報告失敗:', err);
        this.$message.error('載入歷史報告失敗');
      } finally {
        this.loading = false;
      }
    },

    formatReportName(filename) {
      const match = filename.match(/earthquake-report_(\d+)_/);
      return match && match[1] ? `第 ${match[1]} 號地震報告` : filename;
    },

    handlePageChange(page) {
      this.currentPage = page;
    },

    downloadReport(row) {
      const a = document.createElement('a');
      a.href = row.url;
      a.download = row.name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  },
  mounted() {
    this.fetchReports();
  },
};
</script>

<style scoped>
.earthquake-history {
  padding: 40px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.history-card {
  max-width: 1000px;
  margin: 0 auto;
  border-radius: 12px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.08);
}

.card-header {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
}

.header-icon {
  font-size: 22px;
  margin-right: 8px;
  color: #409eff;
}

.header-title {
  font-family: "Microsoft JhengHei", "Segoe UI", sans-serif;
}

.history-table {
  margin-top: 10px;
  font-size: 14px;
  font-family: "Microsoft JhengHei", "Segoe UI", sans-serif;
}

.el-table th {
  background-color: #f0f2f5;
  color: #606266;
  font-weight: 600;
}

.el-table .cell {
  padding: 10px 8px;
}

.pagination-wrapper {
  display: flex;
  justify-content: center;
  margin: 25px 0 10px;
}

.el-pagination {
  font-family: "Microsoft JhengHei", "Segoe UI", sans-serif;
}

.el-button {
  transition: all 0.2s ease;
}

.el-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
}
</style>
